import { DisplayFilters } from './displayFilters';
import { CustomRecord, EnrichedMetadata } from './metadata';

export enum Breakpoint {
  small = 'small', // mobile
  large = 'large', // desktop
}

export type OverridableBreakpoint = Omit<typeof Breakpoint, 'large'>;

export type ValuePerBreakpoint<T> = {
  [K in keyof OverridableBreakpoint]?: T; // specific breakpoint overrides - OPTIONALS
} & {
  default: T; // default breakpoint = largest, from which values should cascade (unless smaller breakpoint value was given - which will break the cascade) - MANDATORY
};

export enum SizingType {
  content = 'content',
  stretched = 'stretched',
  pixels = 'pixels',
}

type InitialSizeSetting =
  | {
      sizingType: Exclude<SizingType, SizingType.pixels>;
    }
  | {
      sizingType: SizingType.pixels;
      pixels: number;
    };

export type ComponentInitialSize = {
  height: InitialSizeSetting;
  width: InitialSizeSetting;
};

export type PresetConfig = {
  id: string;
  thumbnailUrl: string;
  displayName: string;
  optimizedFor?: Breakpoint[];
  displayFilters?: DisplayFilters;
  initialSize?: ComponentInitialSize;
  style: ValuePerBreakpoint<CustomRecord>;
} & EnrichedMetadata;

export type Presets = PresetConfig[];
